export default "__VITE_ASSET__BNL3UZpk__"